import React from 'react';
import { assest } from '../Assest/Assest';
import '../css/About.css'; // Import the CSS file for styles

function About() {
  return (
    <div className="about-container">
      <div className="hero-section">
        <img src={assest.aboutimg} alt="About Dentin Dental Care" className="about-image" />
        <div className="hero-text">
          <h1 className="about-title">ABOUT US</h1>
          <h2 className="about-heading">DENTIN DENTAL CARE</h2>
          <p className="about-subheading">Dr. Jeyavel, MDS, MOI</p>
          <p className="about-description">
            Dentin Dental Care - An Invisalign Studio & Implant Centre. At Dentin Dental Care, we provide exclusive treatment with top dental experts. Call us at <strong>96987704907</strong>.
          </p>
        </div>
      </div>

      <div className="main-content">
        <div className="about-offer-card">
          <h3 className="about-offer">Tired of Old Braces? Switch to Invisalign and Smile with Confidence!</h3>
        </div>

        <div className="section-title">
          <h4>DENTAL IMPLANTS</h4>
        </div>

        <div className="implants-card">
          <ul className="implants-list">
            <li>Implants Look Like Real Teeth - People can’t tell the difference between implant teeth and natural teeth.</li>
            <li>Implants Function Like Real Teeth - Steak, apples, salads. Almost nothing is off the menu with dental implants.</li>
            <li>Implants Integrate Into The Jaw Bone - Unlike flippers or dentures, dental implants can’t slip out! Implants fuse directly into the jawbone and remain permanently anchored in, just like natural tooth roots.</li>
          </ul>
        </div>

        <div className="cta">
          <p>Book your Appointment now at Dentin Dental Care, Gobichettipalayam</p>
        </div>
      </div>
    </div>
  );
}

export default About;
